import { useState } from "react";
import { Badge, Collapse } from "reactstrap";
import { SharedDocumentData } from "../../../../Data/Bonus/Elements";

const SharedDocument = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <div className="document">
      <div className="filter-block">
        <div className="collapse-block open">
          <h5 className="block-title" onClick={() => setIsOpen(!isOpen)}>
            Shared Document
            <Badge color="success" className="sm ms-2">3</Badge>
          </h5>
          <Collapse isOpen={isOpen} className="block-content">
            <ul className="document-list">
              {SharedDocumentData.map((item, index) => (
                <li key={index}>
                  <i className={`ti-${item.icon}`} />
                  <h5>{item.text}</h5>
                </li>
              ))}
            </ul>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default SharedDocument;
